<template>
    <div>
        <v-menu  left offset-x :location="location">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="text"
                    icon
                    variant="text"
                    v-bind="attrs"
                    v-on="on"
                    :disabled="disabled"
                    :loading="loading"
                    :density="density"
                    :size="size"
                >
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>
            <v-list>
            <span v-for="(item, index) in contextMenu" :key="index">
                <v-list-item
                    v-if="item.show === undefined || item.show"
                    :key="index"
                    :value="index"
                    @click="item.event()"
                    density="compact"
                    :class="`${item.color}--text`"
                    :disabled="disabled || loading || item.disabled"
                >
                    <v-icon class="mr-2" :color="item.color">{{ item.icon }}</v-icon>
                    {{ item.title }}
                    <v-chip v-if="item.showIaLabel" label small class="ml-2" text-color="primary"><v-icon class="ai mr-1" small>mdi-creation</v-icon>IA</v-chip>
                </v-list-item>
            </span>
            </v-list>
        </v-menu>
    </div>
</template>

<script>

export default {
  name: "ArdiContextMenu",
  props: {
        contextMenu: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: "default"
        },
        location: {
            type: String,
            default: "start"
        },
        density: {
            type: String,
            default: "default"
        }
  }
};
</script>

<style scoped>

</style>